import Body from "./Body";

function App() {
  return <Body></Body>;
}

export default App;
